// extracted by mini-css-extract-plugin
export var actions = "bM_fm";
export var articleMultipleChoiceCTA = "bM_fx";
export var body = "bM_fz";
export var bodyContainer = "bM_fy";
export var illustration = "bM_fC";
export var selected = "bM_fG";
export var subtitle = "bM_fF";
export var textContent = "bM_fD";
export var tile = "bM_fB";
export var wrapper = "bM_bR";